import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.HTMLAttributes<HTMLDivElement>;

export const AccordionItemContent = ({ className, ...props }: IProps) => {
  return <div className={contentStyle.cls({ className })} {...props} />;
};

const contentStyle = tsv({
  base: "fs-accordion__content",
});
